import type { VueConstructor } from "vue";
import { BrewManError } from "@/app/errors";

let vueRoot: InstanceType<VueConstructor> | undefined = undefined;

export function setRoot(root: InstanceType<VueConstructor>) {
  vueRoot = root;
}

export function useRoot(): InstanceType<VueConstructor> {
  if (vueRoot == undefined) {
    throw new BrewManError("Must call setRoot before using this component");
  }
  return vueRoot;
}
